import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export const LandingDifference = () => (
  <section className="bg-gray-50 py-20" data-testid="landing-difference">
    <div className="max-w-5xl mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <p className="text-sm font-semibold text-emerald-700 mb-3">La diferencia</p>
        <h2 className="font-manrope text-3xl sm:text-4xl font-bold text-gray-900">
          No enviamos mensajes a ciegas
        </h2>
        <p className="text-base text-gray-600 mt-4 leading-relaxed">
          Cada acción se mide contra un grupo de control real, así sabemos si funcionó o si fue casualidad.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-6" data-testid="landing-difference-without">
          <div className="flex items-center gap-2 mb-4 text-gray-500">
            <XCircle className="w-5 h-5" />
            <p className="font-semibold text-sm">Sin grupo de control</p>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            Se manda la campaña a todo el mundo y se mide la mejora general. Imposible saber si esa mejora
            hubiera pasado igual, sin intervenir.
          </p>
        </div>
        <div className="bg-white border-2 border-emerald-600 rounded-2xl p-6" data-testid="landing-difference-with">
          <div className="flex items-center gap-2 mb-4 text-emerald-700">
            <CheckCircle2 className="w-5 h-5" />
            <p className="font-semibold text-sm">Con grupo de control (Persistencia 360)</p>
          </div>
          <p className="text-sm text-gray-600 leading-relaxed">
            Un porcentaje configurable de cada color queda sin recibir la acción. Comparamos su evolución
            contra el grupo accionado y así medimos el impacto real, no el ruido.
          </p>
        </div>
      </div>
    </div>
  </section>
);
